export default __webpack_public_path__ + "static/media/pic3.44e338a4.jpg";